import React from 'react';
import { User, HelpCircle, FileText, LogOut, ChevronRight, ShieldCheck, Crown } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
export function ProfileScreen() {
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-391">
      <header className="bg-[#003366] px-6 pt-12 pb-6 sticky top-0 z-10" data-id="element-392">
        <h1 className="text-2xl font-bold text-white" data-id="element-393">Profil</h1>
      </header>

      <div className="px-6 py-6 space-y-6" data-id="element-394">
        {/* User Info */}
        <div className="flex items-center gap-4 mb-2" data-id="element-395">
          <div className="w-16 h-16 bg-[#003366] rounded-full flex items-center justify-center text-white text-xl font-bold" data-id="element-396">
            AD
          </div>
          <div data-id="element-397">
            <h2 className="text-xl font-bold text-gray-900" data-id="element-398">Amadou Diallo</h2>
            <p className="text-gray-500" data-id="element-399">+221 77 123 4567</p>
          </div>
        </div>

        {/* KYC Status */}
        <Card className="flex items-center justify-between bg-green-50 border-green-100" data-id="element-400">
          <div className="flex items-center gap-3" data-id="element-401">
            <div className="p-2 bg-green-100 rounded-full text-green-600" data-id="element-402">
              <ShieldCheck size={20} data-id="element-403" />
            </div>
            <div data-id="element-404">
              <h3 className="font-semibold text-green-900" data-id="element-405">Compte vérifié</h3>
              <p className="text-xs text-green-700" data-id="element-406">
                Limites augmentées actives
              </p>
            </div>
          </div>
        </Card>

        {/* Plan Card */}
        <Card className="relative overflow-hidden border-[#D4A017]/20" data-id="element-407">
          <div className="absolute top-0 right-0 p-2" data-id="element-408">
            <span className="px-2 py-1 bg-[#D4A017]/10 text-[#D4A017] text-xs font-bold rounded-full uppercase tracking-wide" data-id="element-409">
              Actif
            </span>
          </div>
          <div className="flex items-start gap-3 mb-4" data-id="element-410">
            <div className="p-2 bg-[#003366] text-[#D4A017] rounded-lg" data-id="element-411">
              <Crown size={24} data-id="element-412" />
            </div>
            <div data-id="element-413">
              <h3 className="font-bold text-lg text-gray-900" data-id="element-414">
                Forfait Premium
              </h3>
              <p className="text-gray-500" data-id="element-415">2 000 FCFA / mois</p>
            </div>
          </div>
          <ul className="space-y-2 mb-4" data-id="element-416">
            <li className="flex items-center gap-2 text-sm text-gray-600" data-id="element-417">
              <div className="w-1.5 h-1.5 rounded-full bg-[#D4A017]" data-id="element-418"></div>
              Rechargements Mobile Money gratuits
            </li>
            <li className="flex items-center gap-2 text-sm text-gray-600" data-id="element-419">
              <div className="w-1.5 h-1.5 rounded-full bg-[#D4A017]" data-id="element-420"></div>
              Limites journalières plus élevées
            </li>
            <li className="flex items-center gap-2 text-sm text-gray-600" data-id="element-421">
              <div className="w-1.5 h-1.5 rounded-full bg-[#D4A017]" data-id="element-422"></div>
              Support prioritaire
            </li>
          </ul>
          <Button variant="outline" size="sm" fullWidth data-id="element-423">
            Gérer le forfait
          </Button>
        </Card>

        {/* Limits */}
        <div data-id="element-424">
          <h3 className="text-sm font-semibold text-gray-900 mb-3 uppercase tracking-wide" data-id="element-425">
            Plafonds
          </h3>
          <Card noPadding data-id="element-426">
            <div className="divide-y divide-gray-100" data-id="element-427">
              <div className="p-4 flex justify-between items-center" data-id="element-428">
                <span className="text-sm text-gray-600" data-id="element-429">
                  Dépenses journalières
                </span>
                <span className="font-medium text-gray-900" data-id="element-430">500 000 FCFA</span>
              </div>
              <div className="p-4 flex justify-between items-center" data-id="element-431">
                <span className="text-sm text-gray-600" data-id="element-432">
                  Rechargement mensuel
                </span>
                <span className="font-medium text-gray-900" data-id="element-433">
                  2 000 000 FCFA
                </span>
              </div>
              <div className="p-4 flex justify-between items-center" data-id="element-434">
                <span className="text-sm text-gray-600" data-id="element-435">Retrait DAB</span>
                <span className="font-medium text-gray-900" data-id="element-436">
                  100 000 FCFA/jour
                </span>
              </div>
            </div>
          </Card>
        </div>

        {/* Menu */}
        <div className="space-y-2" data-id="element-437">
          <button className="w-full flex items-center justify-between p-4 bg-white rounded-xl border border-gray-100 hover:bg-gray-50 transition-colors" data-id="element-438">
            <div className="flex items-center gap-3" data-id="element-439">
              <User size={20} className="text-gray-500" data-id="element-440" />
              <span className="font-medium text-gray-900" data-id="element-441">
                Informations personnelles
              </span>
            </div>
            <ChevronRight size={20} className="text-gray-400" data-id="element-442" />
          </button>

          <button className="w-full flex items-center justify-between p-4 bg-white rounded-xl border border-gray-100 hover:bg-gray-50 transition-colors" data-id="element-443">
            <div className="flex items-center gap-3" data-id="element-444">
              <HelpCircle size={20} className="text-gray-500" data-id="element-445" />
              <span className="font-medium text-gray-900" data-id="element-446">Aide & Support</span>
            </div>
            <ChevronRight size={20} className="text-gray-400" data-id="element-447" />
          </button>

          <button className="w-full flex items-center justify-between p-4 bg-white rounded-xl border border-gray-100 hover:bg-gray-50 transition-colors" data-id="element-448">
            <div className="flex items-center gap-3" data-id="element-449">
              <FileText size={20} className="text-gray-500" data-id="element-450" />
              <span className="font-medium text-gray-900" data-id="element-451">
                Conditions générales
              </span>
            </div>
            <ChevronRight size={20} className="text-gray-400" data-id="element-452" />
          </button>

          <button className="w-full flex items-center justify-between p-4 bg-red-50 rounded-xl border border-red-100 hover:bg-red-100 transition-colors mt-4" data-id="element-453">
            <div className="flex items-center gap-3" data-id="element-454">
              <LogOut size={20} className="text-red-600" data-id="element-455" />
              <span className="font-medium text-red-600" data-id="element-456">Se déconnecter</span>
            </div>
          </button>
        </div>
      </div>
    </div>;
}